// extracted by mini-css-extract-plugin
export default {"icon":"icon__zv_HN","iconChild":"iconChild___d0Rn","correct":"correct__yDWhH","partiallyCorrect":"partiallyCorrect__HbSWv","incorrect":"incorrect__ToLFb"};